import Swiper from 'swiper';

export default function () {
    new Swiper('.swiper-container--slider', {
        effect: 'fade',
        loop: true,
        autoplay: true,
        speed: 1000
    });
}
